// SMS recieved
function messageReceieved(otp) {
  const otpElement = document.getElementById("otp");

  // check the browser compatibility
  const smsReceievedEvent = new CustomEvent("smsReceived", {
    detail: {
      otp: otp,
    },
  });
  otpElement.dispatchEvent(smsReceievedEvent);
}

window.messageReceieved = messageReceieved;



// WEBPACK FOOTER //
// src/webview/sms.js